import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";

import Login from "./Login";
import Register from "./Register";
import Projects from "./Projects";
import ProjectDetails from "./ProjectDetails";
import NewDashboard from "./NewDashboard";
import PurchaseOrderReportNew from "./PurchaseOrderReportNew";
import UserList from "./UserList";
import PurchaseEnquiry from "./PurchaseEnquiry";
import ManageRole from "./ManageRole";
import PurchaseRequisition from "./PurchaseRequisition";
import MIROReport from "./MIROReport";
import MIRODetails from "./MIRODetails";
import LeanReport from "./LeanReport";
import LeanDetails from "./LeanDetails";
import Reservation from "./Reservation";
import ReservationDetails from "./ReservationDetails";
import NoteSheet from "./NoteSheet";
import NoteSheetDetails from "./NoteSheetDetails";
import CreateUser from "./CreateUser";
import { UserProvider } from "./UserContext";

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

const App = () => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <UserProvider>
                    <BrowserRouter basename="">
                        <Routes>
                            <Route path="/" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/projects" element={<Projects />} />
                            <Route path="/projectdetails/:id" element={<ProjectDetails />} />
                            <Route path="/newdashboard" element={<NewDashboard />} />
                            <Route path="/purchaseorderreport" element={<PurchaseOrderReportNew />} />
                            <Route path="/userlist" element={<UserList />} />
                            <Route path="/pe" element={<PurchaseEnquiry />} />
                            <Route path="/mr" element={<ManageRole />} />
                            <Route path="/pr" element={<PurchaseRequisition />} />
                            <Route path="/miro-report" element={<MIROReport />} />
                            <Route path="/mirodetails/:id" element={<MIRODetails />} />
                            <Route path="/lean-report" element={<LeanReport />} />
                            <Route path="/lean-details/:id" element={<LeanDetails />} />
                            <Route path="/reservation-list" element={<Reservation />} />
                            <Route path="/reservation-details/:id" element={<ReservationDetails />} />
                            <Route path="/notesheet-list" element={<NoteSheet />} />
                            <Route path="/notesheet-details/:id" element={<NoteSheetDetails />} />
                            <Route path="/create-user" element={<CreateUser />} />
                        </Routes>
                    </BrowserRouter>
                </UserProvider>
            </PersistGate>
        </Provider>
    );
};

const root = createRoot(document.getElementById("root"));
root.render(<App />);
export default App;